import React from 'react'
import { QueryParamProvider } from 'use-query-params'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'

import { PrivateRoutes } from 'components/Router/PrivateRoutes'
import { Assignments } from './Assignments'
import { GenericError } from './GenericError'
import { Triage } from './Formalization/Triage'
import { Analysis } from './Formalization/Analysis'
import { config } from 'config'

const ROUTES = {
  SURPRISE: `${config.baseRoute}/sales-engagement/surprise`,
  ASSIGNMENTS: `${config.baseRoute}/sales-engagement/assignments`,
  TRIAGE: `${config.baseRoute}/sales-engagement/triage`,
  ANALYSIS: `${config.baseRoute}/sales-engagement/analysis`,
  ASSIGNMENTS_DASHBOARD: `${config.baseRoute}/sales-engagement/assignments/dashboard`,
}

const Switcher = () => (
  <Routes>
    <Route
      path={ROUTES.SURPRISE}
      element={<Navigate to={ROUTES.ASSIGNMENTS} replace />}
    />
    <Route element={<PrivateRoutes />}>
      <Route path={ROUTES.ASSIGNMENTS} element={<Assignments />} />
      <Route path={ROUTES.TRIAGE} element={<Triage />} />
      <Route path={ROUTES.ANALYSIS} element={<Analysis />} />
      <Route path={ROUTES.ASSIGNMENTS_DASHBOARD} element={<Assignments />} />
    </Route>
    <Route path="*" element={<GenericError />} />
  </Routes>
)

const Pages = () => {
  return (
    <BrowserRouter>
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <Switcher />
      </QueryParamProvider>
    </BrowserRouter>
  )
}

export { Pages, ROUTES }
